import React, { useCallback } from 'react';
import BookingFormStore from 'Stores/BookingFormStore';
import BookingFlowStatus from 'Components/Front/Booking/BookingFlowStatus';
import SaferpayPaymentKit from 'Components/Front/PaymentForm';
import PlanetPaymentKit from 'Components/Front/PlanetiPageKit';
import StripeForm from 'Components/Front/StripeForm';
import MastercardIcon from 'Icons/Mastercard';
import VisaIcon from 'Icons/Visa';
import { isTrue, num } from 'Shared/utilities';
const {
  app
} = window;
export default function BookingPaymentForm({
  space,
  ...props
}) {
  const booking_id = BookingFormStore.useState(s => s.booking_id);
  const is__free = BookingFormStore.useState(s => s.grand_total > 0 === false);
  const services = BookingFormStore.useState(s => s.services);
  const step = BookingFormStore.useState(s => s.step);
  const handlePaymentFail = useCallback(function ({
    error,
    error_type
  }) {
    BookingFormStore.update(function (store) {
      store.error = error;
    });
  }, []);
  const handlePaymentSuccess = useCallback(function () {
    let total_price = num(window.localStorage.getItem('amount'));
    (services || []).forEach(function (service) {
      total_price = num(total_price + num(service.total_price));
    });
    app.emit({
      event: 'TC_TunnelEvent',
      source: 'BookingComponent.validate',
      data: {
        template: 'confirmation',
        page: 'confirmation',
        booking_id: window.localStorage.getItem('current_booking_id'),
        type: space?.type === 'b_seminar' ? 'seminaire' : 'coworking',
        city: space?._etablishment?.address?.city,
        date: props.date,
        etablishment: space?._etablishment?.name,
        space: space?.name,
        people: props.people,
        booking: props.start && props.end ? props.start + 'h-' + props.end + 'h' : props.start === 'afternoon' ? 'Demi-journée - Après midi' : props.start === 'morning' ? 'Demi-journée - Matin' : props.start === 'day' ? 'Journée' : '',
        services: (services || []).map(service => service.service_info?.title || '').join(' ').trim(),
        price: window.localStorage.getItem('amount'),
        price_with_services: total_price.format('0.00')
      }
    });
    BookingFormStore.update(function (store) {
      ['info', 'error', 'warning'].forEach(field => store[field] = undefined);
    });
    if (typeof props.onSuccess === 'function') {
      props.onSuccess();
    }
  }, [services, props.onSuccess]);
  const is__company_employee = (app.state.session?.user?.roles || []).includes('company_employee');
  const establishment = space?._etablishment;
  const display__payment = [!is__free, step === 2, booking_id ? true : false, !is__company_employee, isTrue(establishment?.has_payment), establishment?.payment_kits ? true : false].every(condition => condition === true);
  if (!display__payment) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "payment-form__title"
  }, "Mode de paiment", /*#__PURE__*/React.createElement("p", {
    className: "payment-form__subtitle"
  }, "Toutes les transactions sont s\xE9curis\xE9es et chiffr\xE9es.")), /*#__PURE__*/React.createElement("div", {
    className: "payment-form__cc"
  }, /*#__PURE__*/React.createElement("div", {
    className: "payment-form__cc-title"
  }, "Carte de cr\xE9dit"), /*#__PURE__*/React.createElement("div", {
    className: "payment-form__cc-text"
  }, "Les moyens de paiement accept\xE9s"), /*#__PURE__*/React.createElement(VisaIcon, {
    className: "payment-form__cc-icon"
  }), /*#__PURE__*/React.createElement(MastercardIcon, {
    className: "payment-form__cc-icon"
  })), isTrue(establishment.payment_kits.saferpay) ? /*#__PURE__*/React.createElement(SaferpayPaymentKit, {
    id: booking_id,
    API_TOKEN: establishment.saferpay_fields_token,
    API_CUSTOMER_ID: establishment.saferpay_customer_id,
    onPaymentFail: handlePaymentFail,
    onSuccess: handlePaymentSuccess
  }) : isTrue(establishment.payment_kits.planet) ? /*#__PURE__*/React.createElement(PlanetPaymentKit, {
    id: booking_id
  }) : isTrue(establishment.payment_kits.stripe) ? /*#__PURE__*/React.createElement(StripeForm, {
    booking: booking_id
  }) : undefined, /*#__PURE__*/React.createElement(BookingFlowStatus, null));
}
